<template>
  <div class="app-container">
    <!--查询组-->
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="keyword">
          <el-input v-model="listQuery.keyword" placeholder="请输入昵称/手机号" clearable @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item prop="keyword">
          <el-select v-model="listQuery.card_type" placeholder="请选择会员卡卡种" clearable @keyup.enter.native="SearchData">
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status">
          <el-select v-model="listQuery.status" placeholder="请选择会员状态" clearable @keyup.enter.native="SearchData">
            <el-option label="生效中" :value="1"></el-option>
            <el-option label="已过期" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="keyword">
          <el-date-picker
            v-model="listQuery.date"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            clearable
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <!-- <el-button v-auth="'User.create'" class="action-item" type="primary" icon="el-icon-edit" @click="HandleCreate">添加</el-button> -->
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <el-table-column align="center" type="selection" />
      <el-table-column align="center" prop="avatar" label="头像" width="120">
        <template slot-scope="{ row }">
          <el-avatar :size="60" :src="row.avatar" @error="true">
            <img :src="base_url+'static/image/default_avatar.png'">
          </el-avatar>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="nickname" label="昵称" />
      <el-table-column align="center" prop="phone" label="手机号" />
      <el-table-column align="center" prop="member_type_name" label="会员卡卡种" />
      <el-table-column align="center" prop="status" label="会员状态">
        <template slot-scope="{ row }">
          {{ row.status | statusTextFilter }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="member_start" label="开始时间"></el-table-column>
      <el-table-column align="center" prop="member_end" label="结束时间"></el-table-column>
      <el-table-column align="center" prop="" label="操作">
        <template slot-scope="scopes">
          <el-button v-auth="'Member.postpone'" type="primary" icon="" plain size="mini" @click="HandleUpdate(scopes.row)">延期</el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog v-loading="yqLoading" title="延期" :visible.sync="dialogFormVisible" width="1030px">
      <div class="box">
        <el-alert title="用户信息" type="success" :closable="false" style="border-radius:0;"></el-alert>
        <el-descriptions class="margin-top" title="" :column="3" size="medium" border :label-style="{'width':'160px'}" :content-style="{'width':'227px'}">
          <el-descriptions-item label="头像">
            <el-avatar :size="25" :src="temp.avatar" @error="true">
              <img :src="base_url+'static/image/default_avatar.png'">
            </el-avatar>
          </el-descriptions-item>
          <el-descriptions-item label="昵称">{{ temp.nickname || '--' }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ temp.phone || '--' }}</el-descriptions-item>
          <el-descriptions-item label="会员状态">{{ temp.status | statusTextFilter }}</el-descriptions-item>
          <el-descriptions-item label="会员卡卡种" :span="2">{{ temp.member_type_name || '--' }}</el-descriptions-item>
          <el-descriptions-item label="开始时间">{{ temp.member_start || '--' }}</el-descriptions-item>
          <el-descriptions-item label="结束时间">{{ temp.member_end || '--' }}</el-descriptions-item>
        </el-descriptions>
        <br>
        <br>
        <!-- <el-alert title="会员卡信息" type="success" :closable="false" style="border-radius:0;"></el-alert>
        <el-descriptions class="margin-top" title="" :column="3" size="medium" border :label-style="{'width':'160px'}" :content-style="{'width':'227px'}">
          <el-descriptions-item label="卡种">{{ temp.card_info?temp.card_info.member_type_name:'--' }}</el-descriptions-item>
          <el-descriptions-item label="价格">{{ temp.card_info?'￥'+temp.card_info.card_price:'--' }}</el-descriptions-item>
          <el-descriptions-item label="有效天数">{{ temp.card_info?temp.card_info.card_days+'天':'--' }}</el-descriptions-item>
        </el-descriptions> -->
        请填写延期天数： <el-input-number v-model="days" :min="1" :step="1" />
        <br>
        <br>
        <!-- <div v-if="!temp.card_info || !temp.card_info.card" style="color:#F56C6C;margin-bottom:10px;">注意：会员卡已不存在，无法延期</div> -->
        <div style="color:#999;">说明：未过期从结束时间开始延期，已过期从当前时间开始延期</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmPostpone">延期</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/user' // 和数据交互相关写在api 方便复用
import typeapi from '@/api/card' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'

export default {
  name: 'Member',
  components: { Pagination },
  // 列绑定格式化器
  filters: {
    statusTextFilter(val) {
      switch (val) {
        case 1: return '生效中'
        case 2: return '已过期'
        default: return '未知'
      }
    },
    typeFilter(type) {
      switch (type) {
        case 1:
          return '月卡'
        case 2:
          return '季卡'
        case 3:
          return '年卡'
        default:
          return ''
      }
    }
  },
  mixins: [commonList],
  data() {
    return {
      base_url: process.env.VUE_APP_BASE_API,
      // api接口方法
      api,
      // 校验
      rules: {
      },
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id',
        status: 1
      },
      temp: {},
      details_id: 0,
      dialogDetailsVisible: false,
      yqLoading: false,
      typeList: [],
      days: 1
    }
  },
  created() {
    this.loadData() // 页面加载创建时加载数据
    this.getType()
  },
  methods: {
    getType() {
      typeapi.TypeList(this.listQuery).then(response => {
        this.typeList = response.data
      })
    },
    // 加载数据表
    loadData() {
      this.listLoading = true
      // 请求前处理
      this.loadListBefore(this.QueryParams)
      this.api.Member(this.listQuery).then(response => {
        if (this.afterLoadData) {
          response.data.items = this.afterLoadData(response.data.items)
        }
        this.list = response.data.items
        this.total = response.data.total
        this.listLoading = false
        this.$previewRefresh() // 为图片预览组件重新刷新url
      })
    },
    resetTemp() {
      this.temp = { id: undefined, status: 1 }
    },
    HandleUpdate(row) {
      this.temp = JSON.parse(JSON.stringify(row)) // copy obj
      this.days = 1
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
    },
    ConfirmPostpone() {
      this.yqLoading = true
      this.api.MemberPostpone({
        user_id: this.temp.id,
        days: this.days
      }).then(() => {
        this.dialogFormVisible = false
        this.yqLoading = false
        this.loadData()
        this.$message({
          message: '延期成功',
          type: 'success'
        })
      }).catch(() => {
        this.yqLoading = false
      })
    }
  }
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 5px;  /* 定义滚动条的宽度 */
}
::-webkit-scrollbar-track {
    background: #ecf5ff; /* 定义轨道的背景颜色 */
}
::-webkit-scrollbar-thumb {
    background: #b3d8ff; /* 定义滑块的背景颜色 */
}
::-webkit-scrollbar-thumb:hover {
    background: #b3d8ff; /* 定义滑块在悬停状态下的背景颜色 */
}
.margin-top {
  margin-top: 0px;
}
</style>
